import { ApplicationRef, ComponentRef, EnvironmentInjector, Injectable, createComponent } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { AlertComponent } from '../components/alert/alert.component'
import { Alert } from '../enums/alert.enum'

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  changeUpdateBarStatus$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  constructor(private _AppRef: ApplicationRef, private _env: EnvironmentInjector) {}
  // TODO: find a better way to do this rather than using componentFactoryResolver
  alert(type: Alert, projectionContent: string, timer: number = 6000): ComponentRef<AlertComponent> | undefined {
    const alertComponentRef = createComponent(AlertComponent, { environmentInjector: this._env })

    alertComponentRef.instance.type = type
    alertComponentRef.instance.timer = timer

    this._AppRef.attachView(alertComponentRef.hostView)

    const domElem = (alertComponentRef.hostView as any).rootNodes[0] as HTMLElement
    document.body.appendChild(domElem)

    // Provide self ref so component can destroy itself cleanly
    alertComponentRef.instance.componentRef = alertComponentRef

    setTimeout(() => {
      const projectionContainer = alertComponentRef.location.nativeElement.querySelector('.projection-container')
      if (projectionContainer) {
        // Convert First letter to upper case
        projectionContainer.innerHTML = projectionContent.charAt(0).toUpperCase() + projectionContent.slice(1)
      }
    }, 0)

    return alertComponentRef
  }
}
